import DatepickerController from "./datepicker_controller"
import { isDateRange } from "../util"

export default class extends DatepickerController {
  initialized = false

  connect() {
    super.connect()
    this.inputTarget.addEventListener("change", this.handleInputChange.bind(this))
    setTimeout(() => this.initialized = true, 0)
  }

  handleInputChange(event) {
    if (!this.initialized) return

    if (this.rangeOnlyValue && !this.isCompleteRangeValue(event?.target?.value)) {
      return
    }

    this.element.closest("form")?.requestSubmit()
  }

  isCompleteRangeValue(value) {
    return value && isDateRange(value)
  }
}
